import Vue from 'vue'
import VueRouter from 'vue-router'

import LoginComponent from '../components/content/Login/LoginComponent.vue'

import Dashboard from '../components/content/Dashboard/DashboardComponent.vue'

import WorkReports from '../components/content/WorkReports/WorkReports.vue'

import StatusReports from '../components/content/StatusReports/ViewStatusReports/StatusReports.vue'
import CreateEditStatusReport from '../components/content/StatusReports/CreateEditStatusReport/CreateEditStatusReport.vue'

import PeerReview from '../components/content/PeerReview/PeerReview.vue'
import ChangePassword from '../components/content/ChangePassword/ChangePassword.vue'

import EditRoles from '@/components/content/Roles/EditRoles/EditRoles.vue'
import ViewRoles from '@/components/content/Roles/ViewRoles/ViewRoles.vue'

import ProjectApplication from '@/components/content/ProjectApplication/Student/ProjectApplication.vue'
import EvaluateProjectApplications from '@/components/content/ProjectApplication/Professor/EvaluateProjectApplications.vue'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    component: Dashboard,
    meta: {
      breadcrumb: 'BREADCRUMB.HOME'
    }
  },

  {
    path: '/login',
    name: 'Login',
    component: LoginComponent
  },

  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      breadcrumb: 'BREADCRUMB.DASHBOARD'
    }
  },

  {
    path: '/workReports',
    name: 'WorkReports',
    component: WorkReports,
    meta: {
      breadcrumb: 'BREADCRUMB.WORK_REPORTS'
    }
  },

  {
    path: '/statusReports',
    name: 'StatusReports',
    component: StatusReports,
    meta: {
      breadcrumb: 'BREADCRUMB.STATUS_REPORTS'
    }
  },

  {
    path: '/createEditStatusReport/:id?',
    name: 'CreateEditStatusReport',
    component: CreateEditStatusReport,
    meta: {
      breadcrumb: 'BREADCRUMB.CREATE_EDIT_STATUS_REPORT'
    }
  },

  {
    path: '/peerReview',
    name: 'PeerReview',
    component: PeerReview,
    meta: {
      breadcrumb: 'BREADCRUMB.PEER_REVIEW'
    }
  },

  {
    path: '/roles',
    name: 'Roles',
    component: ViewRoles,
    meta: {
      breadcrumb: 'BREADCRUMB.ROLES'
    }
  },

  {
    path: '/editRoles',
    name: 'EditRoles',
    component: EditRoles,
    meta: {
      breadcrumb: 'BREADCRUMB.EDIT_ROLES'
    }
  },

  {
    path: '/projectApplication',
    name: 'ProjectApplication',
    component: ProjectApplication,
    meta: {
      breadcrumb: 'BREADCRUMB.PROJECT_APPLICATION'
    }
  },

  {
    path: '/changePassword',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: {
      breadcrumb: 'BREADCRUMB.CHANGE_PASSWORD'
    }
  },

  {
    path: '*',
    name: 'PageNotFound',
    component: () => import('../components/content/PageNotFound/PageNotFound.vue')
  },

  {
    path: '/evaluateApplications',
    name: 'EvaluateApplications',
    component: EvaluateProjectApplications,
    meta: {
      breadcrumb: 'BREADCRUMB.EVALUATE_APPLICATIONS'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
